import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { WorkflowRun, WorkflowRunConclusion, WorkflowRunStatus } from '../_models/WorkflowRun';

@Component({
  templateUrl: './engine-status-modal.component.html',
  styleUrls: ['./engine-status-modal.component.css']
})

export class EngineStatusModalComponent implements OnInit {

  public workflowRuns: WorkflowRun[] = [];

  constructor(private bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    
    for(let r of this.workflowRuns) {

      r.statusName = WorkflowRunStatus[r.status];
      r.conclusionName = WorkflowRunConclusion[r.conclusion];
    }
  }

  close() {
    this.bsModalRef.hide();
  }
}

